import React from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { TargetAudience } from './components/TargetAudience';
import { Bonus } from './components/Bonus';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FinalCTA } from './components/FinalCTA';
export function App() {
  return <main className="min-h-screen bg-slate-50 font-body overflow-x-hidden" data-id="element-0">
      {/* Attention-grabbing announcement bar */}
      <div className="bg-brand-pink text-white text-center text-sm md:text-base font-bold py-2.5 px-4" data-id="element-1">
        🎉 ¡Oferta por tiempo limitado! Lleva tu guía hoy por solo{' '}
        <span className="underline" data-id="element-2">$17</span> en lugar de $47 ✨
      </div>

      <Hero data-id="element-3" />
      <Problem data-id="element-4" />
      <Solution data-id="element-5" />
      <TargetAudience data-id="element-6" />
      <Bonus data-id="element-7" />
      <Testimonials data-id="element-8" />
      <Guarantee data-id="element-9" />
      <FinalCTA data-id="element-10" />

      {/* Simple Footer */}
      <footer className="bg-brand-dark text-white/60 py-8 text-center text-sm" data-id="element-11">
        <p data-id="element-12">
          © {new Date().getFullYear()} Estimulación Temprana en Casa. Todos los
          derechos reservados.
        </p>
        <p className="mt-2" data-id="element-13">Esta página no es parte de Facebook o Meta Inc.</p>
        <nav aria-label="Enlaces legales" className="mt-4 flex justify-center gap-6" data-id="element-14">
          <a href="#" className="text-white/70 hover:text-white underline transition-colors" data-id="element-15">
            Política de Privacidad
          </a>
          <a href="#" className="text-white/70 hover:text-white underline transition-colors" data-id="element-16">
            Términos y Condiciones
          </a>
        </nav>
      </footer>
    </main>;
}